import { Dialog, Button, DialogTitle, DialogContentText, DialogActions, DialogContent } from '@mui/material';
import { formatCurrency, toTitleCase } from '../../../utils';
import { useContent } from '../../../logic'

interface CompletePayloadTaskDialogProps {
    open: boolean;
    setUserCompleteOpen: (open: boolean) => void;
    onUserCompleteTask: () => void;
    total: number
}

export function CompletePayloadTaskAmountRemainingDialog({ open, setUserCompleteOpen, onUserCompleteTask, total }: CompletePayloadTaskDialogProps) {

  const { TaskText } = useContent()
  const totalFormatted = formatCurrency(total)

  return <Dialog key="userComplete" open={open}>
    <DialogTitle>Complete {toTitleCase(TaskText)}</DialogTitle>

    <DialogContent>
      <DialogContentText sx={{ mb: 1 }}>You've submitted {totalFormatted} so far, but there's a remaining balance on your cash to close.</DialogContentText>
      <DialogContentText>Mark this {TaskText} as complete? You won't be able to make any more payments once it's completed.</DialogContentText>
    </DialogContent>

    <DialogActions>
      <Button variant="rounded" onClick={() => setUserCompleteOpen(false)}>
                Not yet
      </Button>
      <Button variant="contained" onClick={onUserCompleteTask}>
                Yes, complete it
      </Button>
    </DialogActions>
  </Dialog>
}
